import React from 'react';

export default function Support() {
  return (
    <div style={{ overflow: 'auto', height: '145vh'}}>
      <iframe
        className="clickup-embed clickup-dynamic-height"
        src="https://forms.clickup.com/3022572/f/2w7qc-2954/WQ2112QO93PM9CWC1W"
        title="ClickUp Form"
        width="100%"
        style={{
          background: 'transparent',
          border: '1px solid #ccc',
          display: 'block',
          overflow: 'scroll',
          height: '140vh',
          marginTop: '20px',
        }}
      ></iframe>
      <script
        async
        src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
      ></script>
    </div>
  );
}
